module.exports = __webpack_public_path__ + "img/0.987ef00e.jpg";